import { string, object, boolean, array, addMethod, number } from 'yup';
import JSONSchema7Properties from '../../Shared/jSONSchema7Properties';
import formatName from '../formatName';

export default (properties: JSONSchema7Properties) => {
  addMethod(array, 'unique', function (message, mapper = (a: string) => a) {
    return this.test('unique', message, function (list) {
      if (list) {
        return list.length === new Set(list.map(mapper)).size;
      }
      return false;
    });
  });

  return object({
    [`${formatName(properties['label']?.$id as string)}`]: string()
      .required('Required')
      .max(250, 'Must be at most 250 characters'),
    [`${formatName(properties['id']?.$id as string)}`]: string()
      .required('Required')
      .matches(/^[a-z0-9]+$/i, 'Must be alphanumeric'),
    [`${formatName(properties['required']?.$id as string)}`]: boolean(),
    [`${formatName(properties['statusEnabled']?.$id as string)}`]: boolean(),
    [`${formatName(properties['options']?.$id as string)}`]: array()
      .of(
        object().shape({
          value: string()
            .required('A value is required for each option.')
            .matches(/^[a-z0-9\s'&,-.<>]+$/i, 'Only letters, numbers, spaces and the following symbols are allowed: \' & , - . < > '),
          id: string().required('An ID is required for each option.'),
          status: string()
        })
      )
      .min(1, 'At least one option is required.')
      .test('differentIDs', 'Option IDs must be unique.', (options) => {
        if (options) {
          return (
            options.length === new Set(options.map((option) => option.id)).size
          );
        }
        return false;
      }),
    [`${formatName(properties['utilizeHiddenComponents']?.$id as string)}`]:
      boolean(),
    [`${formatName(properties['gridSize']?.$id as string)}`]: number()
  });
};
